import React from 'react';
import { Card, SpinnerIcon } from '@avila-tek/ui/src';
import { Kpi } from '../../../../../models';
import KpiItem from './KpiItem';

interface KpisInfoProps {
  kpiItems: Kpi[];
  loading: boolean;
}

function KpisInfo({ kpiItems, loading }: KpisInfoProps) {
  return (
    <Card className="w-full flex p-4">
      <div className="w-full flex flex-col md:flex-row min-h-[60px]">
        {loading ? (
          <div className="w-full flex justify-center items-center">
            <SpinnerIcon className="w-24 h-24 text-gray-200 animate-spin fill-purple-300" />
          </div>
        ) : (
          <div className="w-full flex flex-col md:flex-row min-h-[60px]">
            {kpiItems.map((item, i) => (
              <KpiItem
                idx={i}
                key={`${item?.title}-${item?.total}`}
                total={item?.total}
                title={item?.title}
                difference={item?.difference}
                differenceTitle={item?.differenceTitle}
              />
            ))}
          </div>
        )}
      </div>
    </Card>
  );
}

export default KpisInfo;
